import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion/Accordion";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection/AccordionSection";
import GridContainer from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridItem, Typography } from "@insite/mobius/index";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import Report from "@tKgpco/Components/MyAccount/Reports/Report";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    settings: state.context.settings
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ReportsStyles {
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    poLineTitleGridItem?: GridItemProps;
    packingSlipTitleGridItem?: GridItemProps;
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
    title?: TypographyPresentationProps;
    titleContainer?: GridItemProps;
}

export const reportsStyles: ReportsStyles = {
    accordionSection: {
        panelProps: {
            css: css`
                > div {
                    border-bottom: 1px solid lightgrey;
                    padding-bottom: 15px;
                    margin-bottom: 15px;
                    &:last-of-type {
                        border: none;
                        margin-bottom: 0;
                    }
                }
            `,
        },
    },

    centeringWrapper: {
        css: css`
            display: flex;
            height: 150px;
            justify-content: center;
            align-items: center;
        `,
    },

    titleContainer: {
        width: 12,
    },

    title: {
        weight: "bold",
        css: css`
            font-size: ${TYPOGRAPHY.size.larger};
        `,
    },
};

const styles = reportsStyles;

const reports = [
    {
        id: uniqueId(),
        title: "Purchase History Reports",
        type: "purchaseHistory",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: true,
    },
    {
        id: uniqueId(),
        title: "Back Ordered Items Reports",
        type: "backOrderedItem",
        description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
        isConfigurable: false,
    },
];

const Reports: FC<Props> = ({ id, fields, settings, history }) => {
    const { properties } = settings;
    if(properties.backOrderedItemsReportsType === "OFF" && properties.purchaseHistoryReportsType === "OFF") {
        history.push("/MyAccount");
    }
    return (
        <Accordion {...styles.accordion} headingLevel={3}>
            <ManagedAccordionSection
                title={
                    <GridContainer>
                        <GridItem {...styles.titleContainer}>
                            <Typography as="h2" {...styles.title}>
                                {translate("Reports")}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                }
                initialExpanded={true}
                {...styles.accordionSection}
            >
                {reports.filter(report => {
                    if(report.type === "backOrderedItem") {
                        return !(properties.backOrderedItemsReportsType === "OFF")
                    }
                    if(report.type === "purchaseHistory") {
                        return !(properties.purchaseHistoryReportsType === "OFF")
                    }
                    return true;
                }).map(report => {
                    report.description =
                        report.type === "purchaseHistory"
                            ? fields.purchaseHistoryDescripition
                            : fields.backOrderedItemDescripition;
                    return <Report report={report} key={report.id} />;
                })}
            </ManagedAccordionSection>
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(Reports)),
    definition: {
        displayName: "Reports",
        group: "Common",
        fieldDefinitions: [
            {
                name: "purchaseHistoryDescripition",
                displayName: "Purchase History Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
            {
                name: "backOrderedItemDescripition",
                displayName: "Back Order Item Descripition",
                editorTemplate: "TextField",
                defaultValue:
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
